import { jsx as _jsx } from "react/jsx-runtime";
import { useAudioDevices, useCanAccessCamera, useCanAccessMicrophone, useCurrentAudioDevice, useCurrentVideoDevice, useSetSelectedAudioDevice, useSetSelectedVideoDevice, useVideoDevices, } from '../state/mediaState';
import { ButtonList, ButtonListItem } from './ButtonList';
import { DeviceBlockedPlate } from './DeviceBlockedPlate';
import { BlankIcon, CheckMarkIcon } from './Icon';
function DeviceList({ devices, selectedDevice, onSelectDevice, }) {
    return (_jsx(ButtonList, { children: devices.map((device, index) => (_jsx("li", { children: _jsx(ButtonListItem, { type: "button", onClick: () => {
                    onSelectDevice?.(device);
                }, prependComponent: selectedDevice?.deviceId === device.deviceId ? (_jsx(CheckMarkIcon, {})) : (_jsx(BlankIcon, { size: "1.25rem" })), children: device.label }) }, device.deviceId || index))) }));
}
export function AudioDeviceList({ onDeviceSelect }) {
    const devices = useAudioDevices();
    const currentDevice = useCurrentAudioDevice();
    const setSelectedDevice = useSetSelectedAudioDevice();
    const canAccessMicrophone = useCanAccessMicrophone();
    if (!canAccessMicrophone) {
        return _jsx(DeviceBlockedPlate, { kind: "audio" });
    }
    return (_jsx(DeviceList, { devices: devices, selectedDevice: currentDevice, onSelectDevice: (device) => {
            setSelectedDevice(device);
            onDeviceSelect?.(device);
        } }));
}
export function VideoDeviceList({ onDeviceSelect }) {
    const devices = useVideoDevices();
    const currentDevice = useCurrentVideoDevice();
    const setSelectedDevice = useSetSelectedVideoDevice();
    const canAccessCamera = useCanAccessCamera();
    if (!canAccessCamera) {
        return _jsx(DeviceBlockedPlate, { kind: "video" });
    }
    return (_jsx(DeviceList, { devices: devices, selectedDevice: currentDevice, onSelectDevice: (device) => {
            setSelectedDevice(device);
            onDeviceSelect?.(device);
        } }));
}
